import { CircularSpinner } from '@festina-life/ui/feedback'
import { inputWrapperMinWidthStyles } from '@festina-life/ui/forms'
import cx from 'classnames'

export const CommandPaletteModalSpinner = () => (
  <div
    className={cx(
      'flex grow justify-center items-center',
      inputWrapperMinWidthStyles,
    )}
  >
    <CircularSpinner />
  </div>
)
